import { render, staticRenderFns } from "./CurrentAllowance.vue?vue&type=template&id=28f03f42"
import script from "./CurrentAllowance.vue?vue&type=script&lang=js"
export * from "./CurrentAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports